var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.buttonClassName,attrs:{"disabled":_vm.disabled},on:{"click":_vm.clicked}},[(_vm.loading || _vm.submitted)?_c('v-loader'):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }